import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Link,
} from "react-router-dom";
import Genshin_randomizer from "./GenshinRandomizer/App";
import LandingPage from "./App";
import Profile from "./Profile/app";
import UpdateApiMainPage from "./UpdateDataApi/UpdateApiMainPage";
import Test from "./Test/Test";
import Snowfall from "react-snowfall";
import AiController from "./Test/AiController";
import { DateTime } from "luxon";
import Test2 from "./Test/Test2";
const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/project/genshinrandomizer",
    element: <Genshin_randomizer />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/updateapi",
    element: <UpdateApiMainPage />,
  },
  {
    path: "/test",
    element: <Test />,
  },
  {
    path: "/test2",
    element: <Test2 />,
  },
  {
    path: "/ai",
    element: <AiController />,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const SpecialEvent = () => {
  const now = DateTime.now();

  const visible =
    (now.month === 12 && now.day >= 1) || (now.month === 1 && now.day <= 2);

  return visible ? (
    <Snowfall
      style={{
        position: "fixed",
        width: "100vw",
        height: "100vh",
        zIndex: "100",
      }}
    />
  ) : null;
};

root.render(
  <React.StrictMode>
    <SpecialEvent />
    <RouterProvider router={router} />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
